<template>
	<div id="loading" :class="{ active: loading }">
		<img src="../../assets/images/loading.gif" alt="loading">
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	computed : {
		...mapState({
			loading: state => state.app.loading
		})
	}
}
</script>

<style lang="scss">
#loading {
	display: none;
	position: fixed;
	z-index: 10;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.2);
	img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100px;
	}
}
#loading.active {
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue